import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-result-legend',
  templateUrl: './result-legend.component.html',
  styleUrls: ['./result-legend.component.scss']
})
export class ResultLegendComponent implements OnInit {

  boxs = BOXES;
  vertexes = VERTEXES;
  cables = CABLES;

  constructor() { }

  ngOnInit(): void {
  }

}

const BOXES = [
  { name: 'CTOP 90/10', color: '#00ff00' },
  { name: 'CTOP 85/15', color: '#ffff00' },
  { name: 'CTOP 80/20', color: '#ffffff' },
  { name: 'CTOP 70/30', color: '#0000ff' },
  { name: 'CTOP 60/40', color: '#ff0000' },
  { name: 'CTOP SIMETRICA', color: '#cccccc' },
  { name: 'FIST-144', color: '#ff9900' },
  { name: 'FIST-72', color: '#ff4000' },
  { name: 'FOSC-72', color: '#ff9900' },
  { name: 'FOSC-48', color: '#999933' }
];

const VERTEXES = [
  { name: 'CO', color: '#fbb03b' },
  { name: 'PT', color: '#223b53' },
  { name: 'CA', color: '#e55e5e' },
  { name: 'CS', color: '#3bb2d0' },
];

const CABLES = [
  { name: 'TRUNK', color: '#ff0000' },
  { name: 'CTOP', color: '#eb34cc' },
  { name: 'CDOI', color: '#34ebdb' },
  { name: 'DIST-24', color: '#0000ff' },
  { name: 'DIST-12', color: '#f2fc23' },
];
